import { motion } from "framer-motion";
import { Reveal, MaskLine } from "./Reveal";

const flavors = [
  {
    name: "Dark Chocolate & Hazelnut",
    note: "Belgian chocolate, roasted hazelnuts",
    img: "/flavors/chocolate-hazelnut.png",
  },
  {
    name: "Pistachio",
    note: "Roasted, slow-churned",
    img: "/flavors/pistachio.png",
  },
  {
    name: "Tiramisu",
    note: "Coffee, mascarpone, cocoa dust",
    img: "/flavors/tiramisu.png",
  },
  {
    name: "Lotus Biscoff",
    note: "Caramelised biscuit swirl",
    img: "/flavors/lotus-biscoff.png",
  },
  {
    name: "Mango",
    note: "Alphonso mangoes, whole",
    img: "/flavors/mango.png",
  },
];

export default function Flavors() {
  return (
    <section
      id="flavors"
      className="relative py-28 lg:py-40 px-6 lg:px-10 scroll-mt-20 bg-bgpink"
      data-testid="flavors-section"
    >
      <div className="max-w-[1400px] mx-auto">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-8 mb-16">
          <div className="max-w-2xl">
            <Reveal>
              <p className="uppercase tracking-[0.3em] text-xs font-500 text-cocoa/50 mb-6">
                Signature scoops
              </p>
            </Reveal>
            <h2 className="font-heading font-600 text-cocoa leading-[1.02] tracking-tight text-4xl sm:text-5xl lg:text-6xl">
              <MaskLine>A rotating cast</MaskLine>
              <MaskLine delay={0.08}>of odd favourites.</MaskLine>
            </h2>
          </div>
          <Reveal delay={0.15}>
            <p className="text-cocoa/60 max-w-sm text-base leading-relaxed">
              Our menu changes with the seasons. Here are five that keep earning
              their place in the case.
            </p>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {flavors.map((f, i) => (
            <motion.div
              key={f.name}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: (i % 3) * 0.1 }}
              className="group"
              data-testid={`flavor-card-${i}`}
            >
              <div className="relative aspect-[4/5] rounded-t-full rounded-b-3xl overflow-hidden bg-vanilla border border-cocoa/10">
                <img
                  src={f.img}
                  alt={`${f.name} gelato in an Odd Scoops cup`}
                  loading="lazy"
                  className="absolute inset-0 w-full h-full object-cover group-hover:scale-105 transition-transform duration-700 ease-out"
                />
                <span className="absolute top-5 left-5 font-heading font-600 text-cocoa/70 text-lg mix-blend-multiply">
                  0{i + 1}
                </span>
              </div>
              <div className="mt-6 flex items-baseline justify-between">
                <h3 className="font-heading font-500 text-2xl text-cocoa tracking-tight">
                  {f.name}
                </h3>
              </div>
              <p className="text-cocoa/60 text-sm mt-1">{f.note}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
